import React, { useEffect, useState } from "react";
import ControlLayout from "../components/ControlLayout";
import { api } from "../lib/api";

export default function ControlAudit() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const fetch = () => api.get("/audit/logs?limit=200").then((r) => setLogs(r.data));
    fetch();
    const i = setInterval(fetch, 8000);
    return () => clearInterval(i);
  }, []);

  const filtered = logs.filter((l) => !filter || l.event_type.toLowerCase().includes(filter.toLowerCase()));

  return (
    <ControlLayout title="Audit Log" subtitle="Every scan, override and device change — immutable trail">
      <div className="panel">
        <div className="panel-header">
          <span className="mono-label">Events · {filtered.length}</span>
          <input
            data-testid="audit-filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="filter by event type…"
            className="h-8 px-2 border border-neutral-300 font-mono text-xs w-64"
          />
        </div>
        <div className="max-h-[70vh] overflow-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="bg-[#FAFAFA] border-b border-neutral-200 sticky top-0">
              <tr className="text-left">
                <Th>Time</Th><Th>Event</Th><Th>Severity</Th><Th>Actor</Th><Th>Payload</Th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((l) => (
                <tr key={l.id} className="border-b border-neutral-100 hover:bg-neutral-50" data-testid={`audit-row-${l.id}`}>
                  <td className="px-4 py-2 font-mono text-xs whitespace-nowrap">{new Date(l.created_at_iso).toLocaleString("en-GB")}</td>
                  <td className="px-4 py-2 font-mono text-xs font-semibold">{l.event_type}</td>
                  <td className="px-4 py-2"><Sev s={l.severity} /></td>
                  <td className="px-4 py-2 font-mono text-xs">{Object.entries(l.actor || {}).map(([k, v]) => `${k}=${v}`).join(" ")}</td>
                  <td className="px-4 py-2 font-mono text-[11px] text-neutral-700 break-all">{JSON.stringify(l.payload)}</td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={5} className="p-8 text-center mono-label">No entries.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </ControlLayout>
  );
}

const Th = ({ children }) => <th className="px-4 py-2 mono-label text-left" style={{ fontSize: 10 }}>{children}</th>;

function Sev({ s }) {
  const map = {
    HIGH: "border-[#EF4444] bg-[#FEE2E2] text-[#991B1B]",
    MEDIUM: "border-[#EAB308] bg-[#FEF9C3] text-[#854D0E]",
    LOW: "border-neutral-400 bg-neutral-100",
    INFO: "border-[#22C55E] bg-[#DCFCE7] text-[#166534]",
  };
  return <span className={`px-2 py-0.5 border font-mono text-[10px] uppercase tracking-wider ${map[s] || "border-neutral-300"}`}>{s}</span>;
}
